import { LogManager, ClientActivityTracker, DeviceAccessor, ServiceAddresses } from "@mcleod/core";
import { PageHeaderProvider, WebMainPage } from "@mcleod/common";
import { ImagingModelDataChangeFilterInitializer } from "../general/src/ImagingModelDataChangeFilterInitializer";
import { ImagingPageHeaderProvider } from "../general/src/ImagingPageHeaderProvider";
import { ImagingSettingsInitializer } from "../general/src/ImagingSettingsInitializer";

const rootElement = document.getElementById("root");
if (rootElement == null)
    throw new Error("Could not mount component because DOM element named root could not be found.");
provideAppSpecificConfiguration();
const mainPage = new WebMainPage({
    apiContext: "mcleod-api-imaging",
    modules: [
        { path: "designer", context: require["context"]("@mcleod/designer/src", true) },
        { path: "common", context: require["context"]("@mcleod/common/src", true) },
        { path: "imaging", context: require["context"]("@mcleod/imaging/src", true) },
    ]
});
rootElement.appendChild(mainPage._element);

function provideAppSpecificConfiguration() {
    DeviceAccessor.initialize();
    ServiceAddresses.setLocalHostServerPort(8010);
    new ImagingSettingsInitializer().initialize();
    new ImagingModelDataChangeFilterInitializer().initialize();
    PageHeaderProvider.set(new ImagingPageHeaderProvider());
    ClientActivityTracker.initializeGlobalListeners();
    const log = LogManager.getLogger("lib.util.api");
    log.debug = log.info;
    log.isDebugEnabled = () => true;
}
